export default __webpack_public_path__ + "static/media/resubmissionRequested.5d5a0e2e.svg";